import { render, staticRenderFns } from "./LocalPostsList.vue?vue&type=template&id=4a971c44&scoped=true&"
import script from "./LocalPostsList.vue?vue&type=script&lang=js&"
export * from "./LocalPostsList.vue?vue&type=script&lang=js&"
import style0 from "./LocalPostsList.vue?vue&type=style&index=0&id=4a971c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a971c44",
  null
  
)

export default component.exports